module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-popup', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "id": _vm.nameId,
      "opened": _vm.popupOpened
    },
    on: {
      "popup:opened": function($event) {
        _vm.popupOpened = true
      },
      "popup:closed": function($event) {
        _vm.popupOpened = false
      }
    }
  }, [_c('page-nav-bar', {
    attrs: {
      "subNavTitle": _vm.switchProfile_SwitchProfile,
      "closePopup": _vm.closeButton,
      "notLeftPanel": true,
      "notReturnButton": true,
      "picker": false
    }
  }), _vm._v(" "), _c('f7-list', {
    staticClass: "switchProfileList",
    attrs: {
      "media-list": ""
    }
  }, _vm._l((_vm.accounts), function(accountItem) {
    return _c('f7-list-item', {
      key: accountItem.id,
      staticClass: "boxRequest",
      class: {
        'disabled': _vm.notActive(accountItem.clearance)
      },
      attrs: {
        "media": '<div class=\'manualChip\'>' + accountItem.name[0].toUpperCase() + '</div>',
        "title": accountItem.name,
        "subtitle": accountItem.identifier,
        "badge": _vm.selected(accountItem.id),
        "text": _vm.noAccess(accountItem.clearance)
      },
      on: {
        "click": function($event) {
          return _vm.switchAccount(accountItem.id)
        }
      }
    })
  }), 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6a42a70a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a42a70a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/popups/switchProfile/switchProfile.vue
// module id = 1687
// module chunks = 2